type DataLayerValue = string | number | boolean;

export function pushEvent(
  event: string,
  extraProperties?: Record<string, DataLayerValue>
) {
  console.info("gtm pushEvent", event, extraProperties);
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event,
      ...extraProperties,
    });
  }
}

export function pushVariable(
  variableName: string,
  variableValue: DataLayerValue
) {
  console.info("gtm pushVariable", variableName, variableValue);
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "setVariable",
      [variableName]: variableValue,
    });
  }
}
